// DISABLED: Animated Background Effects
// Now using global optimized particles in theme-switcher.js
// This file is kept for compatibility but functionality is disabled

console.log('Animated background effects disabled - using global optimized particles');
